import { MuscleGroup } from '../types'

// Muscle group display constants
export const MUSCLE_GROUP_DISPLAY_NAMES: Record<MuscleGroup, string> = {
  chest: 'Chest',
  lats: 'Lats',
  upperBack: 'Upper Back',
  rearDelts: 'Rear Delts',
  lateralDelts: 'Lateral Delts',
  frontDelts: 'Front Delts',
  biceps: 'Biceps',
  triceps: 'Triceps',
  quads: 'Quads',
  hamstrings: 'Hamstrings',
  glutes: 'Glutes',
  adductors: 'Adductors',
  calves: 'Calves',
  abs: 'Abs',
  forearms: 'Forearms',
  neck: 'Neck'
}

export const MUSCLE_GROUP_COLORS: Record<MuscleGroup, string> = {
  chest: '#ef4444',
  lats: '#3b82f6',
  upperBack: '#8b5cf6',
  rearDelts: '#06b6d4',
  lateralDelts: '#10b981',
  frontDelts: '#f59e0b',
  biceps: '#ec4899',
  triceps: '#84cc16',
  quads: '#f97316',
  hamstrings: '#6366f1',
  glutes: '#14b8a6',
  adductors: '#a855f7',
  calves: '#ef4444',
  abs: '#22c55e',
  forearms: '#64748b',
  neck: '#94a3b8'
}

export const MUSCLE_GROUP_EMOJIS: Record<MuscleGroup, string> = {
  chest: '💪',
  lats: '🔥',
  upperBack: '🎯',
  rearDelts: '🎯',
  lateralDelts: '💪',
  frontDelts: '💪',
  biceps: '💪',
  triceps: '💪',
  quads: '🦵',
  hamstrings: '🦵',
  glutes: '🍑',
  adductors: '🦵',
  calves: '🦵',
  abs: '🔥',
  forearms: '💪',
  neck: '🎯'
}

export const ANATOMICAL_MUSCLE_ORDER: MuscleGroup[] = [
  'neck',
  'frontDelts',
  'lateralDelts',
  'rearDelts',
  'chest',
  'upperBack',
  'lats',
  'biceps',
  'triceps',
  'forearms',
  'abs',
  'quads',
  'hamstrings',
  'glutes',
  'adductors',
  'calves'
]
